import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function Testimonials() {
    const { t } = useTranslation();
    const [feedbacks, setFeedbacks] = useState([]);

    useEffect(() => {
        fetch("https://ligasos-laravel.ligasos.co/api/feedbacks")
            .then((response) => response.json())
            .then((data) => setFeedbacks(data))
            .catch((error) => console.error("Error fetching feedbacks:", error));
    }, []);

    const showData = feedbacks.map((el) => {
        const totalStars = 5;
        const filledStars = parseInt(el.rating);

        return (
            <div
                key={el.id}
                className="flex flex-col gap-[15px] justify-between w-[350px] h-auto border border-black rounded-[8px] p-[20px]"
            >
                <div className="flex items-center gap-[5px]">
                    {Array.from({ length: totalStars }, (_, i) => (
                        <img
                            key={i}
                            className="w-[25px] h-[25px]"
                            src={
                                i < filledStars
                                    ? require("../../assets/icons/star.svg").default
                                    : require("../../assets/icons/star-empty.svg").default
                            }
                            alt=""
                        />
                    ))}
                </div>
                <div>
                    <img
                        className="w-[35px] h-[35px]"
                        src={require("../../assets/icons/qote.svg").default}
                        alt=""
                    />
                </div>
                <p className="text-gray-600 italic leading-[1.1]">❝ {t(el.comment)} ❞</p>
                <div className="font-bold capitalize">{t(el.name)}</div>
            </div>
        );
    });

    return (
        <>
            <section className="testimonials-landing">
                <div className="container relative h-full flex flex-col items-center justify-center">
                    <div>
                        <div className="btmAni2000 font-bold text-white text-[40px] capitalize">
                            {t("Customer Reviews")}
                        </div>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[40px]">
                    <div className="js-scroll fade-top flex flex-col gap-[3px]">
                        <div className="text-[30px] font-bold text-[#0B2C3D]">
                            {t("Clients Feedback")}
                        </div>
                        <img
                            className="h-[3px]"
                            src={require("../../assets/icons/line-text.svg").default}
                            alt=""
                        />
                    </div>
                    <div className="flex flex-wrap gap-[20px] justify-between">
                        <div className="flex flex-wrap gap-[20px]">{showData}</div>
                    </div>
                </div>
            </section>
        </>
    );
}